import React, {Fragment, PureComponent} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.scss'
import moment from 'moment';
import 'moment/locale/he';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import {AppContext} from "../../Utils/AppContext";
import uuid from "uuid";
import CloseIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/AddRounded';

moment.locale('he');

export default class ChangeGroupDialog extends PureComponent {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {};
    }

    handleClose() {
        if (this.props.onCancel)
            this.props.onCancel();

        this.setState(
            {
                selectedGroupId: undefined
            }
        );
    }

    async handleSave() {
        if (this.state.selectedGroupId) {
            if (this.props.onSave) {
                this.props.onSave(this.props.order, this.state.selectedGroupId !== "new" ? this.state.selectedGroupId : uuid.v4());
            }

            this.setState(
                {
                    selectedGroupId: undefined
                }
            );
        }
    }

    onGroupSelect(groupId) {
        this.setState({
            selectedGroupId: groupId === this.state.selectedGroupId ? undefined : groupId
        });
    }

    renderGroupListItem(groupId) {
        return (
            <ListItem
                id={`group-change-listitem-${groupId}`}
                key={`group-change-listitem-${groupId}`}
                className="group-item"
                role={undefined}
                button
                selected={this.state.selectedGroupId === groupId}
                onClick={this.onGroupSelect.bind(this, groupId)}
            >
                <div className="pin-icon">
                    {groupId !== "new" ?
                        this.context.iconColors.getPinIconByGroupId(groupId)
                        :
                        <Fragment>
                            {this.context.iconColors.getAvailableColor().pinIcon}
                            <div className="new-pin-icon-container">
                                <AddIcon/>
                            </div>
                        </Fragment>
                    }
                </div>
            </ListItem>
        );
    }

    render() {
        return (
            <Dialog
                className="change-group-dialog"
                open={this.props.open}
                onClose={this.handleClose.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle className="dialog-title" id="form-dialog-title">שינוי מסלול להזמנה</DialogTitle>
                <DialogContent>
                    {this.props.order ?
                        (() => {
                            const availableProposedGroupsToChangeTo = this.props.proposedGroups.filter(group => group.id !== this.props.order.groupId);

                            const orderGroup = this.props.proposedGroups.find(group => group.id === this.props.order.groupId);

                            const shouldShowNewProposedGroup = orderGroup.route.length > 1;

                            return <div className="groups-options">
                                <div className="groups-list-container proposed-groups">
                                    {
                                        availableProposedGroupsToChangeTo.length > 0 || shouldShowNewProposedGroup ?
                                            <Fragment>
                                                <div className="group-category-title-container">
                                                    <div className="group-category-title">
                                                        ממתינות
                                                    </div>
                                                </div>
                                                <List className="groups-list" component="nav">
                                                    {
                                                        availableProposedGroupsToChangeTo.map((group) => this.renderGroupListItem(group.id))
                                                    }
                                                    {
                                                        shouldShowNewProposedGroup
                                                            ?
                                                            this.renderGroupListItem("new")
                                                            :
                                                            null
                                                    }
                                                </List>
                                            </Fragment>
                                            :
                                            <div>
                                                אין מסלולים ממתינים
                                            </div>
                                    }
                                </div>
                            </div>;
                        })()
                        :
                        false
                    }
                </DialogContent>
                <DialogActions className="dialog-buttons">
                    <IconButton className="close-button"
                                onClick={this.handleClose.bind(this)}>
                        <CloseIcon fontSize="medium"/>
                    </IconButton>
                    <Button variant="contained" color="primary" onClick={this.handleSave.bind(this)}
                            disabled={this.state.selectedGroupId === undefined}>
                        שמור
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}